export default function ItineraryActivities() {
    return (<>
        <p>Itineraries Activities</p>
    </>);
}